import request from '@/utils/request'

//往来单位

//查询次信息员列表
export function getDwcxxy(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwcxxy/list",
        data: data
    })
}
//选择从业人员作为次信息员
export function getCyryxx() {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwcxxy/getCyryxx"
    })
}
//发送验证码
export function sendYzm(id) {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwcxxy/sendYzm/"+id
    })
}
//新增次信息员
export function dwcxxySave(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwcxxy/save",
        data:data
    })
}
//查看次信息员详情
export function getDetail(id) {
    return request({
        method: 'get',
        url: "/yzdservice/enterprise/dwcxxy/detail/"+id
    })
}
//停用次信息员
export function disabledWcxxy(id) {
    return request({
        method: 'put',
        url: "/yzdservice/enterprise/dwcxxy/disable/"+id
    })
}
//恢复启用次信息员
export function enableWcxxy(id) {
    return request({
        method: 'put',
        url: "/yzdservice/enterprise/dwcxxy/enable/"+id
    })
}
//移除次信息员
export function removeCgly(id) {
    return request({
        method: 'put',
        url: "/yzdservice/enterprise/dwcxxy/removeCgly/"+id
    })
}
//移交主信息员身份
export function changeZxxySf(id) {
    return request({
        method: 'put',
        url: "/yzdservice/enterprise/dwcxxy/changeZxxySf/"+id
    })
}
//重置次信息员密码
export function resetPwd(data) {
    return request({
        method: 'post',
        url: "/yzdservice/enterprise/dwcxxy/resetPwd",
        data:data
    })
}
